export const UPDATE_PARTS_STATE = 'UPDATE_PARTS_STATE';
export const UPDATE_PARTS_LIST_STATE = 'UPDATE_PARTS_LIST_STATE';
export const ADD_TO_PARTS_LIST_ARRAY = 'ADD_TO_PARTS_LIST_ARRAY';
export const ADD_MORE_PARTS_TO_CART = 'ADD_MORE_PARTS_TO_CART';
export const UPDATE_INITIAL_PART_ADDED_QUANTITY = 'UPDATE_INITIAL_PART_ADDED_QUANTITY';
export const POPULATE_PARTS_STATE = 'POPULATE_PARTS_STATE';
export const UPDATE_FAVORITE_PARTS = 'UPDATE_FAVORITE_PARTS';
